import { get } from 'lodash';

const getBaseLanguageCodes = (rootState) =>
  get(rootState, 'config.service.common.ws_language_codes.base', []);

export default getBaseLanguageCodes;
